module.exports = __webpack_public_path__ + "img/anchor5.d376aa90.jpg";